import React, { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { StriimTypography, StriimTooltip } from "@striim/striim-ui";

import { styles } from "./schemasTablesFrame.styles";
import { SidebarCollapse } from "src/generic/icon/customIcons";

interface SchemasTablesFrameInterface {
    children: React.ReactNode;
    Header?: React.ReactNode;
    LeftSidebar?: React.ReactNode;
    showLeftSidebar?: boolean;
    leftSidebarTitle?: string;
    MainSectionTitle?: React.ReactNode;
    schemaType: string;
    compact?: boolean;
}

const SchemasTablesFrame: React.FC<SchemasTablesFrameInterface> = ({
    Header,
    LeftSidebar,
    children,
    showLeftSidebar = true,
    leftSidebarTitle = "",
    MainSectionTitle,
    schemaType,
    compact = false
}) => {
    const [leftSidebarOpened, setLeftSidebarOpened] = useState(true);

    const toggleLeftSidebar = () => setLeftSidebarOpened(prevValue => !prevValue);

    return (
        <Box sx={[styles.stFrameContainer, compact && styles.stFrameContainerCompact]}>
            <Box sx={styles.stMainFrameElement}>
                <Box sx={styles.stLeftSection}>
                    <Box sx={compact ? {} : styles.stHeadingElement}>{Header}</Box>
                    <Box sx={{ ...styles.stChildContainer, ...(compact && styles.stChildContainerCompact) }}>
                        {showLeftSidebar && (
                            <Box
                                sx={
                                    leftSidebarOpened
                                        ? compact
                                            ? styles.stChildLeftSidebarCompact
                                            : styles.stChildLeftSidebar
                                        : styles.stChildLeftSidebarClosed
                                }
                            >
                                <Box
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={leftSidebarOpened ? "space-between" : "center"}
                                    py={compact ? 1 : 1.5}
                                    pl={leftSidebarOpened ? (compact ? 1.5 : 3) : 2}
                                    pr={compact ? 1 : 2}
                                >
                                    {leftSidebarOpened ? (
                                        <>
                                            <StriimTypography variant="h4" color="primary.700">
                                                {leftSidebarTitle}
                                            </StriimTypography>

                                            <IconButton onClick={toggleLeftSidebar} sx={styles.iconWrapper}>
                                                <SidebarCollapse />
                                            </IconButton>
                                        </>
                                    ) : (
                                        <StriimTooltip
                                            title={`Expand to view the list of ${schemaType.toLowerCase()}s`}
                                            placement="right"
                                        >
                                            <IconButton
                                                onClick={toggleLeftSidebar}
                                                sx={[styles.iconWrapper, styles.expanded]}
                                            >
                                                <SidebarCollapse />
                                            </IconButton>
                                        </StriimTooltip>
                                    )}
                                </Box>
                                {leftSidebarOpened && LeftSidebar}
                            </Box>
                        )}
                        <Box sx={compact ? styles.stChildMainSectionCompact : styles.stChildMainSection}>
                            {MainSectionTitle ? MainSectionTitle : null}

                            {children}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default SchemasTablesFrame;
